/* SAR services not available in production api-services build
import type { ExternalTableSchema } from '@packages/table-builder';

export const sarAwardApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'SAR Award Approval Queue',
    entity: 'SarAwardApproval',
    description: 'Review and approve or reject pending SAR award grants.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/sar-award-approval/sar-award-list',
    method: 'GET',
    rowIdField: 'sarAwardId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'StatusIds',
        placeholder: 'Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/sar-award/sar-award-statuses',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'participantName',
      header: 'Participant',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'grantNo',
      header: 'Grant #',
      type: 'text',
      sortable: true,
      width: 120,
    },
    {
      field: 'grantName',
      header: 'Grant Name',
      type: 'text',
      sortable: true,
      width: 150,
    },
    {
      field: 'unitsGranted',
      header: 'Units Granted',
      type: 'number',
      sortable: true,
      width: 120,
      align: 'center',
    },
    {
      field: 'basePrice',
      header: 'Base Price',
      type: 'currency',
      sortable: true,
      width: 110,
      align: 'center',
    },
    {
      field: 'issueDate',
      header: 'Grant Date',
      type: 'date',
      sortable: true,
      width: 120,
      align: 'center',
    },
    {
      field: 'planName',
      header: 'Plan',
      type: 'text',
      sortable: true,
      width: 140,
    },
    {
      field: 'statusName',
      header: 'Approval Status',
      type: 'badge',
      sortable: true,
      width: 130,
      align: 'center',
      badge: {
        statusMap: {
          Pending: 'info',
          Approved: 'success',
          Rejected: 'error',
          Cancelled: 'default',
          Expired: 'error',
        },
        defaultVariant: 'default',
      },
    },
    {
      field: 'isAccepted',
      header: 'Accept Status',
      type: 'badge',
      sortable: true,
      width: 130,
      align: 'center',
      badge: {
        statusMap: { true: 'success', false: 'error' },
        defaultVariant: 'error',
      },
      conditionalValues: { true: 'Accepted', false: 'Needs Acceptance' },
    },
    {
      field: 'awardStatus',
      header: 'Award Status',
      type: 'text',
      sortable: false,
      width: 130,
    },
    {
      field: 'outstandingPrice',
      header: 'Outstanding Price',
      type: 'currency',
      sortable: false,
      width: 140,
      align: 'center',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_SAR_AWARD_APPROVAL_OVERVIEW', label: 'View Overview' },
      { id: 'VIEW_SAR_AWARD_APPROVAL_VESTING', label: 'View Vesting' },
      { id: 'VIEW_SAR_AWARD_APPROVAL_DOCUMENTS', label: 'View Documents' },
      { id: 'APPROVE_SAR_AWARD', label: 'Approve' },
      { id: 'REJECT_SAR_AWARD_APPROVAL', label: 'Reject', variant: 'danger' },
    ],
    bulk: [
      { id: 'BULK_APPROVE_SAR_AWARD', label: 'Approve' },
      { id: 'BULK_REJECT_SAR_AWARD', label: 'Reject', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: true, placeholder: 'Search' },
    pagination: { mode: 'pagination' },
    selection: {
      keyField: 'sarAwardId',
      selectable: { field: 'statusName', operator: 'EQUAL', value: 'Pending' },
    },
    columnPreferences: {
      persistenceKey: 'SarAwardApproval',
      resizable: true,
      reorderable: true,
    },
    defaultSort: { field: 'issueDate', direction: 'desc' },
  },
};

*/
